import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList } from "vue";
const _hoisted_1 = { class: "container" };
const _hoisted_2 = {
    key: 2,
    class: "row cart"
};
const _hoisted_3 = { class: "col-md-8 pr-4" };
const _hoisted_4 = {
    class: "col-md-4 border-left pl-4",
    style: { "color": "#323232" }
};
const _hoisted_5 = ["action", "accept-charset", "target"];
const _hoisted_6 = ["name", "value"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_cart_checkout__empty = _resolveComponent("g-cart-checkout__empty");
    const _component_g_cart_checkout__thankyou = _resolveComponent("g-cart-checkout__thankyou");
    const _component_g_cart_checkout__messages = _resolveComponent("g-cart-checkout__messages");
    const _component_g_cart_checkout__notes = _resolveComponent("g-cart-checkout__notes");
    const _component_g_cart_checkout__summary = _resolveComponent("g-cart-checkout__summary");
    const _component_g_cart_checkout__cart = _resolveComponent("g-cart-checkout__cart");
    const _component_g_cart_checkout__bonus = _resolveComponent("g-cart-checkout__bonus");
    const _component_g_cart_checkout__details = _resolveComponent("g-cart-checkout__details");
    const _component_g_cart_checkout__activate = _resolveComponent("g-cart-checkout__activate");
    const _component_g_cart_checkout__shipping = _resolveComponent("g-cart-checkout__shipping");
    const _component_g_cart_checkout__payment = _resolveComponent("g-cart-checkout__payment");
    const _component_g_cart_checkout__reject = _resolveComponent("g-cart-checkout__reject");
    const _component_g_cart_checkout__finalize = _resolveComponent("g-cart-checkout__finalize");
    const _component_g_cart_checkout__sidbar = _resolveComponent("g-cart-checkout__sidbar");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.isEmpty)
            ? (_openBlock(), _createBlock(_component_g_cart_checkout__empty, {
                key: 0,
                cart: _ctx.cart,
                schema: _ctx.schema,
                data: _ctx.data,
                status: _ctx.status,
                onCommand: _ctx.onCommand
            }, null, 8, ["cart", "schema", "data", "status", "onCommand"]))
            : (_ctx.status.mode === 'thankyou')
                ? (_openBlock(), _createBlock(_component_g_cart_checkout__thankyou, {
                    key: 1,
                    cart: _ctx.cart,
                    schema: _ctx.schema,
                    data: _ctx.data,
                    status: _ctx.status,
                    onCommand: _ctx.onCommand
                }, null, 8, ["cart", "schema", "data", "status", "onCommand"]))
                : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        (_ctx.status.messages)
                            ? (_openBlock(), _createBlock(_component_g_cart_checkout__messages, {
                                key: 0,
                                cart: _ctx.cart,
                                schema: _ctx.schema,
                                data: _ctx.data,
                                status: _ctx.status,
                                onCommand: _ctx.onCommand
                            }, null, 8, ["cart", "schema", "data", "status", "onCommand"]))
                            : _createCommentVNode("", true),
                        (_ctx.schema?.messages)
                            ? (_openBlock(), _createBlock(_component_g_cart_checkout__notes, {
                                key: 1,
                                cart: _ctx.cart,
                                schema: _ctx.schema,
                                data: _ctx.data,
                                status: _ctx.status,
                                onCommand: _ctx.onCommand
                            }, null, 8, ["cart", "schema", "data", "status", "onCommand"]))
                            : _createCommentVNode("", true),
                        (_ctx.schema?.summary)
                            ? (_openBlock(), _createBlock(_component_g_cart_checkout__summary, {
                                key: 2,
                                cart: _ctx.cart,
                                schema: _ctx.schema,
                                data: _ctx.data,
                                status: _ctx.status,
                                onCommand: _ctx.onCommand
                            }, null, 8, ["cart", "schema", "data", "status", "onCommand"]))
                            : _createCommentVNode("", true),
                        (_ctx.data)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                (_ctx.status.mode === 'cart')
                                    ? (_openBlock(), _createBlock(_component_g_cart_checkout__cart, {
                                        key: 0,
                                        cart: _ctx.cart,
                                        schema: _ctx.schema,
                                        data: _ctx.data,
                                        status: _ctx.status,
                                        onCommand: _ctx.onCommand
                                    }, null, 8, ["cart", "schema", "data", "status", "onCommand"]))
                                    : _createCommentVNode("", true),
                                (_ctx.status.mode === 'bonus')
                                    ? (_openBlock(), _createBlock(_component_g_cart_checkout__bonus, {
                                        key: 1,
                                        cart: _ctx.cart,
                                        schema: _ctx.schema,
                                        data: _ctx.data,
                                        status: _ctx.status,
                                        onCommand: _ctx.onCommand
                                    }, null, 8, ["cart", "schema", "data", "status", "onCommand"]))
                                    : (_ctx.status.mode === 'details')
                                        ? (_openBlock(), _createBlock(_component_g_cart_checkout__details, {
                                            key: 2,
                                            cart: _ctx.cart,
                                            schema: _ctx.schema,
                                            data: _ctx.data,
                                            status: _ctx.status,
                                            onCommand: _ctx.onCommand
                                        }, null, 8, ["cart", "schema", "data", "status", "onCommand"]))
                                        : (_ctx.status.mode === 'activate')
                                            ? (_openBlock(), _createBlock(_component_g_cart_checkout__activate, {
                                                key: 3,
                                                cart: _ctx.cart,
                                                schema: _ctx.schema,
                                                data: _ctx.data,
                                                status: _ctx.status,
                                                onCommand: _ctx.onCommand
                                            }, null, 8, ["cart", "schema", "data", "status", "onCommand"]))
                                            : (_ctx.status.mode === 'shipping')
                                                ? (_openBlock(), _createBlock(_component_g_cart_checkout__shipping, {
                                                    key: 4,
                                                    cart: _ctx.cart,
                                                    schema: _ctx.schema,
                                                    data: _ctx.data,
                                                    status: _ctx.status,
                                                    onCommand: _ctx.onCommand
                                                }, null, 8, ["cart", "schema", "data", "status", "onCommand"]))
                                                : (_ctx.status.mode === 'payment')
                                                    ? (_openBlock(), _createBlock(_component_g_cart_checkout__payment, {
                                                        key: 5,
                                                        cart: _ctx.cart,
                                                        schema: _ctx.schema,
                                                        data: _ctx.data,
                                                        status: _ctx.status,
                                                        onCommand: _ctx.onCommand
                                                    }, null, 8, ["cart", "schema", "data", "status", "onCommand"]))
                                                    : (_ctx.status.mode === 'reject')
                                                        ? (_openBlock(), _createBlock(_component_g_cart_checkout__reject, {
                                                            key: 6,
                                                            cart: _ctx.cart,
                                                            schema: _ctx.schema,
                                                            data: _ctx.data,
                                                            status: _ctx.status,
                                                            onCommand: _ctx.onCommand
                                                        }, null, 8, ["cart", "schema", "data", "status", "onCommand"]))
                                                        : ((_ctx.status.mode === 'summary' || _ctx.status.mode === 'reject'))
                                                            ? (_openBlock(), _createBlock(_component_g_cart_checkout__finalize, {
                                                                key: 7,
                                                                cart: _ctx.cart,
                                                                schema: _ctx.schema,
                                                                data: _ctx.data,
                                                                status: _ctx.status,
                                                                onCommand: _ctx.onCommand
                                                            }, null, 8, ["cart", "schema", "data", "status", "onCommand"]))
                                                            : _createCommentVNode("", true)
                            ], 64))
                            : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_4, [
                        _createVNode(_component_g_cart_checkout__sidbar, {
                            cart: _ctx.cart,
                            schema: _ctx.schema,
                            data: _ctx.data,
                            status: _ctx.status,
                            onCommand: _ctx.onCommand
                        }, null, 8, ["cart", "schema", "data", "status", "onCommand"])
                    ])
                ])),
        (_ctx.oci)
            ? (_openBlock(), _createElementBlock("form", {
                key: 3,
                name: "ociform",
                ref: "ociform",
                method: "post",
                action: _ctx.oci.hookUrl,
                "accept-charset": _ctx.oci.charset,
                target: _ctx.oci.hookTarget
            }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.oci.fields, (field) => {
                    return (_openBlock(), _createElementBlock("input", {
                        type: "hidden",
                        name: field.name,
                        value: field.value
                    }, null, 8, _hoisted_6));
                }), 256))
            ], 8, _hoisted_5))
            : _createCommentVNode("", true)
    ]));
}
